<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div class="uploaded-files">
        <div class="upload-sec">
          <div class="row">
            <div class="col-sm-12">
              <div class="block drop-container" (ngxf-drop)="uploadFile($event)" (ngxf-select)="uploadFile($event)"
                drop-class="drop" [ngxf-validate]="{ size: { min: 5 } }" multiple>
                <p>Drop file(s) to upload</p>
                <label class="btn btn-primary btn-bs-file">
                  <svg class="btnIcon" xmlns="http://www.w3.org/2000/svg" width="15.238" height="15.238"
                    viewBox="0 0 15.238 15.238" fill="#fff">
                    <g id="Add" transform="translate(0.25 0.25)">
                      <path id="Path_4" data-name="Path 4"
                        d="M36.5,36.624H33.242a.242.242,0,0,0-.242.242v.242h0a.242.242,0,0,0,.242.242H36.5a.121.121,0,0,1,.121.121v3.262h0a.242.242,0,0,0,.242.242h.242a.242.242,0,0,0,.242-.242V37.47h0a.121.121,0,0,1,.121-.121h3.262a.242.242,0,0,0,.242-.242v-.242h0a.242.242,0,0,0-.242-.242H37.47a.121.121,0,0,1-.121-.121V33.242h0A.242.242,0,0,0,37.107,33h-.242a.242.242,0,0,0-.242.242V36.5h0A.121.121,0,0,1,36.5,36.624Z"
                        transform="translate(-29.618 -29.618)" stroke-width="0.5" fill-rule="evenodd" />
                      <path id="Path_5" data-name="Path 5"
                        d="M26.369,33.013a6.644,6.644,0,1,0-6.644-6.644A6.644,6.644,0,0,0,26.369,33.013Zm0,.725a7.369,7.369,0,1,1,7.369-7.369A7.369,7.369,0,0,1,26.369,33.738Z"
                        transform="translate(-19 -19)" stroke-width="0.5" />
                    </g>
                  </svg>
                  Browse Files</label>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-15 upload-wrap dd-overflow-inherit" [formGroup]="documentUploadForm">
          <div class="uploaded-form" *ngIf="documentUploadForm.value.filename">
            <div class="row">
              <div class="col-sm-2">
                <div class="media">
                  <div class="media-left">
                    <span>
                      <em class="fa fa-file"></em>
                    </span>
                  </div>
                  <div class="media-body">
                    <h4 class="media-heading">{{ documentUploadForm.get('filename')?.value }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-9">
                <div class="row">
                  <div class="col-sm-6 required" *ngIf="is_fileupload">
                    <input type="text" class="form-control" formControlName="title" placeholder="Title" />
                  </div>
                  <div class="col-sm-6 required" *ngIf="is_fileupload">
                    <div class="select-icon">
                      <select name="" class="form-control" formControlName="documenttype"
                        (change)="getDocumentCategories($event.target.value)">
                        <option value="">Select Document Type</option>
                        <option *ngFor="let attachment of documentTypes" [value]="attachment.valueText">
                          {{ attachment.valueText }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6 required" *ngIf="is_fileupload">
                    <div class="select-icon">
                      <select name="" class="form-control" formControlName="documentcategory">
                        <option value="">Select Document Category</option>
                        <option *ngFor="let attachment of documentCategories" [value]="attachment.valueText">
                          {{ attachment.valueText }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer p-3">
  <p-button label="Send" styleClass="btn px-3 py-1 mr-2 " (click)="sendDocument()"> </p-button>
</div>
